module.exports = __webpack_public_path__ + "static/media/JA_I2.cc571525.png";